module.exports = __webpack_public_path__ + "img/close.366de977.svg";